import { render, staticRenderFns } from "./Calendar.vue?vue&type=template&id=3005fbf7&scoped=true"
import script from "./Calendar.vue?vue&type=script&lang=ts"
export * from "./Calendar.vue?vue&type=script&lang=ts"
import style0 from "./Calendar.vue?vue&type=style&index=0&id=3005fbf7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3005fbf7",
  null
  
)

export default component.exports